// extracted by mini-css-extract-plugin
export default {"completion":"index_completion__ufvo8"};